import { combineReducers } from "redux";
import layout from "./layout/reducer";
import login from "./login/reducer";
import forgetPassword from "./forgetPwd/reducer";
import cognitoUser from "./CognitoUser/reducer";
import organization from "./organization/reducer";
import orgAccount from "./orgAcct/reducer"
import globalLicense from "./globalLicense/reducer";
import customLicense from "./customLicense/reducer";
import globalIaac from "./globalIaac/reducer";
import organizationIaac from "./organizationIaac/reducer";
import orgUsers from "./orgUsers/reducer";
import malwareScan from "./malwareScan/reducer";
import freeLicense from "./freeLicense/reducer";
import deleteProspectiveSellRecordSlice from "./organization/deleteProspectiveSellRecordSlice";
import organizationBillingSlice from "./organizationBilling/organizationBillingSlice";
import organizationBillingUsageSlice from "./organizationBillingUsage/organizationBillingUsageSlice";

const rootReducer = combineReducers({
    layout,
    //Added the following
    login,
    forgetPassword,
    cognitoUser,
    organization,
    orgAccount,
    globalLicense,
    customLicense,
    globalIaac,
    organizationIaac,
    orgUsers,
    malwareScan,
    freeLicense,
    deleteProspectiveSellRecordSlice,
    organizationBillingSlice,
    organizationBillingUsageSlice
});

export default rootReducer;